<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/document-management/new-documents"></back-button>
          Update New Document
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Document Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/document-management/new-documents`"
              >New Documents</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="general-tab"
                  data-bs-toggle="tab"
                  href="#general"
                  role="tab"
                  aria-controls="general"
                  aria-selected="true"
                  >General</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="comment-tab"
                  data-bs-toggle="tab"
                  href="#comment"
                  role="tab"
                  aria-controls="comment"
                  aria-selected="false"
                  >Comments</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For General Sectiion -->
              <div
                class="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <h4>General</h4>
                <hr />
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Vessel Name</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.vessel_id"
                          :suggestions="vessels"
                          placeholder="Select Vessel name"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Category</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.category_id"
                          :suggestions="categories"
                          placeholder="Select Category name"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Title</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.title"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Title"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-4">
                      <label class="col-sm-4 col-form-label"
                        >Sequence Number</label
                      >
                      <div class="col-sm-8">
                        <input
                          type="text"
                          v-model="form.sequence_number"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Sequence Number"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Date</label>
                      <div class="col-sm-9">
                        <my-datepicker
                          :date.sync="form.date"
                          placeholder="Enter Date"
                        ></my-datepicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Edited By</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.edited_by"
                          :suggestions="edited"
                          placeholder="Select Edited By"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Revision</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.revision"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Revision"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-4">
                      <label class="col-sm-4 col-form-label">Edition</label>
                      <div class="col-sm-8">
                        <input
                          type="text"
                          v-model="form.edition"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Edition"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Description</label>
                      <div class="col-sm-9">
                        <textarea
                          name="Description"
                          class="form-control"
                          placeholder="Description"
                          id=""
                          cols="5"
                          rows="5"
                          v-model="form.description"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Document Format</label
                      >
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.document_format"
                          :suggestions="documentFormats"
                          placeholder="Select Document Format"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Document Type</label
                      >
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.document_type"
                          :suggestions="documentTypes"
                          placeholder="Select Document Type"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-4">
                      <label class="col-sm-4 col-form-label">Filepath</label>
                      <div class="col-sm-8">
                        <input
                          type="file"
                          name="attachment"
                          ref="file"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Attachment"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Working State</label
                      >
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.working_state"
                          :suggestions="workingStates"
                          placeholder="Select Workng State"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Remarks</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.remark"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Remarks"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Reference Number</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.reference_number"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Reference Number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-4">
                      <label class="col-sm-4 col-form-label"
                        >Close Document</label
                      >
                      <div class="col-sm-8">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_close_document"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- For Tap 4 -->
              <div
                class="tab-pane fade"
                id="comment"
                role="tabpanel"
                aria-labelledby="comment-tab"
              >
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table id="dataTableExample" class="table table-hover">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Commented By</th>
                          <th>Commented Date</th>
                          <th>Comments</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <loading-table
                          :isLoading="isLoading"
                          cols="14"
                        ></loading-table>
                        <tr v-if="form.document_comments.length == 0">
                          <td colspan="14" class="text-center">
                            No data Found
                          </td>
                        </tr>
                        <tr
                          v-for="(doc, sr) in form.document_comments"
                          :key="`doc${sr}`"
                        >
                          <td>{{ sr + 1 }}.</td>
                          <td>
                            <input
                              v-uppercase
                              type="text"
                              class="form-control"
                              placeholder="Commented By"
                              v-model="doc.commented_by"
                              readonly
                            />
                          </td>
                          <td>
                            <my-datepicker
                              :date.sync="doc.comment_date"
                              :id="`comment_date${sr}`"
                              placeholder="Enter Commented Date"
                            ></my-datepicker>
                          </td>
                          <td>
                            <input
                              v-uppercase
                              type="text"
                              class="form-control"
                              placeholder="Comments"
                              v-model="doc.comments"
                            />
                          </td>
                          <td>
                            <div class="text-center">
                              <button
                                class="btn btn-danger btn-sm"
                                @click="deleteDocumentComment(doc)"
                                v-if="!doc.id"
                              >
                                Delete
                              </button>
                              <button
                                class="btn btn-danger btn-sm"
                                @click="delete_document_comment_data(doc.id)"
                                v-else
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="form.document_comments">
                          <td
                            colspan="14"
                            align="center"
                            @click="addEmptyDocumentComments()"
                            style="
                              background-color: #6571ff;
                              color: white;
                              border-radius: 10px;
                              box-shadow: none;
                            "
                          >
                            Add New Row
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- /Table -->
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "Vessel Update",
  data() {
    return {
      form: {
        vessel_id: "",
        category_id: "",
        edited_by: "",
        document_format: "",
        document_type: "",
        working_state: "",
        document_comments: [],
      },
      vessels: [],
      categories: [],
      edited: [],
      documentFormats: [],
      documentTypes: [],
      workingStates: [],
    };
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("documents/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.categories.forEach((category) => {
        this.categories.push({
          id: category.id,
          name: category.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/documents/${this.$route.params.documentId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.post(`/documents`, this.form);
        this.isLoading = false;
        this.$router.push("/document-management/new-documents");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.imagepath = this.$refs.imagepath
        ? this.$refs.imagepath.files[0]
        : "";
      this.attachment = this.$refs.attachment
        ? this.$refs.attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("imagepath", this.imagepath);
      formData.append("attachment", this.attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    async handleDocumentUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    deleteDocumentComment(speed) {
      this.form.document_comments = this.form.document_comments.filter(
        (ar) => ar != speed
      );
    },
    addEmptyDocumentComments() {
      this.form.document_comments.push({
        commented_by: this.company.name,
        commented_date: "",
        comment: "",
      });
    },
    async delete_document_comment_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=document_comments`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
